import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Banner } from 'dig-components/banner';
import { Title, Text } from 'dig-components/typography';
import { Checkbox } from 'dig-components/controls';
import { UIIcon } from 'dig-components/icons';
import { Twinkle2Fill } from 'dig-components/dist/icons/src';

import Spacer, { SpacerSize } from 'hellospa/foundation/spacing/spacer';
import { trackHeapCustomEvent } from 'common/utils/heap';
import styles from './styles.scss';

type Props = {
  OnToggleCheckBox: (shouldConvert: boolean) => void,
  shouldConvertDocToTemplate: boolean,
};

const DocToTemplateBanner: React.FunctionComponent<Props> = ({
  OnToggleCheckBox,
  shouldConvertDocToTemplate,
}) => {
  const trackLearnMoreLink = () => {
    trackHeapCustomEvent('doc_to_template_v2_learn_more_link');
  };
  return (
    <Spacer top={SpacerSize.XL} bottom={SpacerSize.XL}>
      <Banner
        variant="basic"
        className={styles.docToTemplateBannerColor}
        withLeftIcon={<UIIcon className={styles.docToTemplateBannerIconColor} src={Twinkle2Fill} size={'large'} />}
      >
        <Banner.Message>
          <Title size={'small'} className={styles.docToTemplateBannerTitle}>
            <FormattedMessage
              id=''
              description='text in doc to template banner, asking user if they want to create this document to template'
              defaultMessage='Want to use this document again in the future?' />
          </Title>
          <div className={styles.docToTemplateCheckbox}>
            <Spacer right={SpacerSize.SM}>
              <Checkbox
                size={16}
                onChange={() => OnToggleCheckBox(!shouldConvertDocToTemplate)}
                id='signed-copies'
                data-qa-ref='doc-to-template-banner-upload-page'
                checked={shouldConvertDocToTemplate} />
            </Spacer>
            <Text>
              <FormattedMessage
                id=''
                description='text in doc to template banner, asking user if they want to create this document to template'
                defaultMessage="Yes, I'd like to save this as a reusable template after documents are sent. <a>Learn more</a>"
                values={{
                  // eslint-disable-next-line react/display-name
                  a: (...chunks: []) => <a className={styles.docToTemplateLink} href='https://www.hellosign.com/features/templates' onClick={trackLearnMoreLink} target='_blank' rel="noreferrer">{chunks}</a>,
                }} />
            </Text>
          </div>
        </Banner.Message>
      </Banner>
    </Spacer>
  );
};

export default DocToTemplateBanner;
